import React from 'react'
import {
  ErrorLoadingRetry,
  useReportEntry,
  ReportEntryFieldsDisplayRenderer,
} from '@therms/react-modules'
import {Loading} from '@therms/atalaya'

interface SingleEntryDisplayProps {
  entryId?: string
  reportId: string
}

function SingleEntryDisplay({entryId, reportId}: SingleEntryDisplayProps) {
  const {data, loading, refresh} = useReportEntry(
    entryId ? {entryId, reportId} : undefined,
  )

  if (!data && loading)
    return (
      <div className="h-20 w-full">
        <Loading message="Loading Entry" overlay />
      </div>
    )

  if (!data?.entry)
    return (
      <div className="h-20 w-full">
        <ErrorLoadingRetry onRetry={refresh} />
      </div>
    )

  return (
    <div className="relative">
      <div className="p-sm">
        <ReportEntryFieldsDisplayRenderer
          formId={data.entry.formInput.formId}
          valuesByFieldId={data.entry.formInput.fields}
        />
      </div>
    </div>
  )
}

export {SingleEntryDisplay}
